module.exports = __webpack_public_path__ + "img/shadow_amulet.aa91bde9.png";